import { useCallback, useEffect, useRef } from 'react';
// @ts-expect-error Because it is an external module
import { TypingText } from '../../../modules/typing-jp/typing_text.js';
import { useTypingWords } from '../../../hooks/api/useTypingWords';

export const useTyping = (typingGradeId: number) => {
  const { getTypingWords, isLoading, error, typingWords } = useTypingWords();
  const availableIndexesRef = useRef<number[]>([]);

  const shuffleArray = useCallback((array: number[]) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }, []);

  const initializeAvailableIndexes = useCallback(() => {
    if (!typingWords?.length) return;

    const allIndexes = Array.from({ length: typingWords.length }, (_, index) => index);
    availableIndexesRef.current = shuffleArray(allIndexes);
  }, [typingWords, shuffleArray]);

  const isValidInputKey = useCallback((key: string) => {
    return TypingText.isValidInputKey(key);
  }, []);

  const createTypingText = useCallback(async () => {
    if (!typingWords?.length) {
      return null;
    }

    if (availableIndexesRef.current.length === 0) {
      initializeAvailableIndexes();
    }

    const selectedIndex = availableIndexesRef.current.pop();
    if (selectedIndex === undefined) {
      return null;
    }

    const selectedWord = typingWords[selectedIndex];

    return {
      word: selectedWord.inputWord,
      displayWord: selectedWord.displayWord,
      typingText: new TypingText(selectedWord.inputWord),
    };
  }, [typingWords, initializeAvailableIndexes]);

  const resetTypingList = useCallback(() => {
    availableIndexesRef.current = [];
  }, []);

  useEffect(() => {
    resetTypingList();
    getTypingWords(typingGradeId);
  }, [resetTypingList, typingGradeId, getTypingWords]);

  useEffect(() => {
    if (typingWords?.length) {
      initializeAvailableIndexes();
    }
  }, [typingWords, initializeAvailableIndexes]);

  return {
    createTypingText,
    resetTypingList,
    isValidInputKey,
    isLoading,
    error,
    typingWords,
  };
};
